import { useEffect, useState } from "react";
import { ActionIcon, Group, Text } from "@mantine/core";
import { IconReload } from "@tabler/icons-react";
import { useLocalStorage } from "@mantine/hooks";
import { fetchTableItemsCounts } from "../api/dynamodb-db-api";

export default function TableItemsCount({ label, apiPath }: { label: string, apiPath: string }) {
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const [tableItemsCount, setTableItemsCount] = useLocalStorage<{
        count: number,
        lastFetch: number
    }>({ key: `${label}Count`, getInitialValueInEffect: false });

    async function fetch() {
        setLoading(true);
        const response = await fetchTableItemsCounts(apiPath);
        if (!(response instanceof Error)) {
            setCount(response.data);
            setTableItemsCount({ count: response.data, lastFetch: Date.now() });
        }
        setLoading(false);
    }

    useEffect(() => {
        if (tableItemsCount) {
            if (Date.now() - tableItemsCount.lastFetch > 1000 * 60 * 60)
                fetch();
            else
                setCount(tableItemsCount.count);
        } else fetch();
    }, [tableItemsCount]);

    return (
        <Group gap={4} align="center" style={{ background: "transparent", padding: 0 }}>
            <Text size="sm" style={{ fontSize:"13px",  padding: 0, margin: 0 }}>
              Total Size :  {count}
            </Text>

            <ActionIcon
                variant="transparent"
                onClick={fetch}
                loading={loading}
                style={{ padding: 0, margin: 0 }}
            >
                <IconReload size={14} />
            </ActionIcon>
        </Group>
    );
}

